import { useGlobalStore } from '~/stores/useGlobalStore';

export default defineNuxtRouteMiddleware((to, from) => {
    const globalStore = useGlobalStore();
    const publicRoutes = ['/login', '/signup', '/forgot-password', '/reset-password', '/terms'];
    const authEntryRoutes = ['/login', '/signup', '/forgot-password', '/reset-password'];

    if (!globalStore.isAuthenticated && !publicRoutes.includes(to.path)) {
        return navigateTo('/login', { replace: true });
    }

    if (globalStore.isAuthenticated && (authEntryRoutes.includes(to.path) || to.path === '/')) {
        return navigateTo('/dashboard', { replace: true });
    }
});